import { addOrUpdateByExcelName, getExcelByName } from '@/services/build';
import { useRequest } from 'ahooks';

const Excel = () => {
  const { data: excelInfo, run: getExcelInfo } = useRequest(getExcelByName, {
    manual: true,
  });
  const { run: runaddOrUpdateExcelByName } = useRequest(
    addOrUpdateByExcelName,
    {
      manual: true,
      onSuccess: (res, param) => {
        console.log(param);
        if (param[0]?.bizLine) {
          getExcelInfo({
            bizLine: param[0]?.bizLine,
            bizPlate: param[0]?.bizPlate || bizPlate || '',
          });
        }
      },
    },
  );
  return {
    runaddOrUpdateExcelByName,
    excelInfo,
    getExcelInfo,
  };
};
export default Excel;
